module.exports = __webpack_public_path__ + "img/metamask.96518a15.svg";